import { ROUTES } from "@app/constants";

export function getClosureDetailPath(briefId: string, userId: string): string {
  return ROUTES.CLOSURE_DETAIL.replace(":briefId", briefId).replace(
    ":userId",
    userId
  );
}

export function openClosureDetail(briefId: string, userId: string): void {
  window.open(getClosureDetailPath(briefId, userId), "_blank");
}
